export default __webpack_public_path__ + "images/30_2_image.jpg";